/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React, { useState } from "react"
import { IRecord } from "../../types/schema"
import { useGlobalState } from "../GlobalStateProvider"
import { useAsyncEffect } from "../../hooks/useAsyncEffect"
import { Fields, Form2 } from "@cd2/forms"

type IProductGroups = IRecord<"product_groups", "description" | "code">

export function ProductGroupSelect({
  value,
  onChange,
  disabled,
  error,
  required,
  branchId,
  isClearable,
  filter,
  label,
}: {
  value?: string
  onChange(id: string, productGroup: IProductGroups): void
  disabled?: boolean
  error?: string
  required?: boolean
  isClearable?: boolean
  branchId?: string
  filter?: any
  label?: React.ReactNode
}) {
  const [isLoading, setIsLoading] = useState(true)
  const skeem = window.skeem
  const { currentUser } = useGlobalState()

  const [productGroups, setProductGroups] = useState<IProductGroups[]>([])

  function handleChange(id: string) {
    console.log(id)
    onChange(id, productGroups.find(w => w.id === id)!)
  }

  useAsyncEffect(async () => {
    try {
      const productGroups = await skeem.fetch2<IProductGroups[]>({
        model: {
          name: "product_groups",
          attributes: ["description", "code"],
          filter: {
            and: [{ matches: { branch: branchId ?? currentUser.branch.id } }, filter].filter(
              Boolean,
            ),
          },
          sort: { by: "code", direction: "asc" },
        },
      })
      setProductGroups(productGroups)
    } finally {
      setIsLoading(false)
    }
  }, [branchId])

  const accountRefCss = css`
    font-size: 12px;
    font-weight: 600;
    color: #999;
  `

  return (
    <Fields.Select2
      label={
        label ?? (
          <Form2.FieldLabel fieldName="product_group" label="Product group" required={required} />
        )
      }
      options={productGroups}
      onChange={value => handleChange(value?.id)}
      value={productGroups.find(v => v.id === value)}
      getOptionLabel={opt => opt.description}
      getOptionValue={opt => opt.id}
      disabled={disabled}
      error={error}
      isClearable={isClearable}
      isLoading={isLoading}
      components={{
        SingleValue: props => {
          const { innerProps, getStyles } = props
          const productGroup = props.data

          return (
            <div
              {...innerProps}
              style={{
                ...getStyles("singleValue", props),
              }}
            >
              <div>{productGroup?.description}</div>
              <div css={accountRefCss}>{productGroup?.code}</div>
            </div>
          )
        },
        Option: props => {
          const { innerProps, innerRef, getStyles } = props
          const productGroup = props.data as IProductGroups

          return (
            <div
              ref={innerRef}
              {...innerProps}
              style={{
                ...getStyles("option", props),
              }}
            >
              <div>{productGroup?.description}</div>
              <div css={accountRefCss}>{productGroup?.code}</div>
            </div>
          )
        },
      }}
    />
  )
}
